import { Icon } from '@chakra-ui/react';
import { ReactComponent as EmptyOrders } from '../../../assets/empty-orders.svg';
import { Empty, EmptyProps } from '../../../components/Empty';

export const EmptyCaptureAttemptsState = (props: EmptyProps) => {
  return (
    <Empty {...props} title="No captures yet" icon={<Icon fontSize="96px" as={EmptyOrders} />} />
  );
};
